import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretUp12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCaretUp12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.204 8.68a.5.5 0 0 1 0-.708L5.648 3.53 6 3.175l.354.354 4.442 4.442a.5.5 0 1 1-.708.707L6.001 4.589l-4.09 4.09a.5.5 0 0 1-.707 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretUp12);
